export default __webpack_public_path__ + "static/media/Peace of Mind - Icon.5cd883b0.svg";